<template>
  <v-container class="mt-10 pl-8">
    <v-layout row>
      <v-flex offset-sm5 >
        <img src="../assets/remindo.png" alt="">
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <h4 class="mt-1">Sign up</h4>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12>
        <form>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-col cols="11" lg="12" sm="12">
                <v-text-field
                  v-model="newUser.fullName"
                  label="Name*"
                  prepend-icon="person"
                  required
                ></v-text-field>
              </v-col>
            </v-flex>
          </v-layout>
          

          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-col cols="11" lg="12" sm="12">
                <v-text-field
                  v-model="newUser.email"
                  label="Email*"
                  prepend-icon="mail"
                  required
                ></v-text-field>
              </v-col>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-col cols="11" lg="12" sm="12">
                <v-text-field
                  v-model="newUser.phoneNumber"
                  label="Phone Number(+234-XXXXXXXXXX)*"
                  hint="To be used to send SMS"
                  prepend-icon="phone"
                  required
                ></v-text-field>
              </v-col>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-col cols="11" lg="12" sm="12">
                <v-text-field
                  v-model="newUser.password"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  label="Password*"
                  prepend-icon="lock"
                  hint="At least 6 characters"
                  @click:append="showPassword = !showPassword"
                  required
                ></v-text-field>
              </v-col>
            </v-flex>
          </v-layout>
          
          <!-- Buttons -->
          <v-layout row>
            <v-flex xs12 md6 offset-sm3>
              <v-col>
                <v-btn
                  color="success"
                  class="mx-2"
                  @click="createUser"
                  :disabled="!formIsValid || disabled"
                  id="tura"
                  >Sign Up</v-btn
                >
              </v-col>
              <v-col>
                Already have an account <a depressed color="white" class="px-0" href="/login">login</a>
              </v-col>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
      <v-snackbar v-model="snackbar" :color="snackbarColor" top>
        {{snackbarText}}
      </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      disabled: false,
      showPassword: false,
      snackbarText: null,
      snackbarColor: null,
      snackbar: false,
      newUser: {
        email: null,
        phoneNumber: null,
        fullName: null,
        password: null,
      }
    };
  },
  methods: {
    createUser() {
      if (!this.formIsValid) {
        return;
      }
      this.disabled = true
      let payload = this.newUser;
      payload.userId = Date.now().toString(36)
      this.$network.post(`/user/register`, payload).then(response=>{
        const user = response.data.user
        console.log({response});
        this.snackbarColor = 'success'
        this.snackbar = true
        this.snackbarText = 'User created successfully'
        this.$store.dispatch("saveUser", user);
        this.$register();
        this.$router.push('/agenda/upcoming')
      }).catch(err=>{
        this.snackbarColor = 'red'
        if (err.response.status === 400) {
          this.snackbar = true
          this.snackbarText = 'User with the email already exist'
        }
        else {
          this.snackbar = true
          this.snackbarText = 'Something went wrong, try again'
        }
      }).finally(()=>{
        this.disabled = false
      })
    }
  },
  computed: {
    formIsValid() {
      return (
        this.newUser.fullName !== null &&
        this.newUser.email !== null &&
        this.newUser.password !== null &&
        this.newUser.password.length >= 6 &&
        this.newUser.phoneNumber !== null
      );
    }
  }
};
</script>

<style scoped>
  img {
    border-radius: 50%;
    width: 150px;
    margin: 12px;
  }
  @media screen and (max-width: 400px) {
    img {
      margin-left: 70px;
      margin-right: 70px;
    }
  }
</style>
